import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { downloadFile } from 'src/app/common/util';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HumanResourcesService } from 'src/app/services/human-resources.service';

@Component({
  selector: 'app-human-resources-report',
  templateUrl: './human-resources-report.component.html',
  styleUrls: ['./human-resources-report.component.scss']
})
export class HumanResourcesReportComponent {
  permissionType = PermissionTypeEnum;

  selectedReport = 0;

  selectedYear: number = new Date().getFullYear();
  selectedMonth: number = new Date().getMonth() + 1;

  months = [
    { value: 1, label: 'Enero' },
    { value: 2, label: 'Febrero' },
    { value: 3, label: 'Marzo' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Mayo' },
    { value: 6, label: 'Junio' },
    { value: 7, label: 'Julio' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Septiembre' },
    { value: 10, label: 'Octubre' },
    { value: 11, label: 'Noviembre' },
    { value: 12, label: 'Diciembre' }
  ];

  annualReport = {
    name: 'Reporte de Recursos Humanos Anual',
    excel: false,
    permissions: [5000, 5092],
    endPoint: (type: string) =>
      this.humanResourcesService.getHumanResourcesReportAnual(this.selectedYear, type)
  };

  monthlyCompleteReport = {
    name: 'Reporte de Recursos Humanos Mensual Completo',
    excel: false,
    permissions: [5000, 5093],
    endPoint: (type: string) =>
      this.humanResourcesService.getHumanResourcesReportMonthlyComplete(
        this.selectedYear,
        this.selectedMonth,
        type
      )
  };

  constructor(
    private toastService: ToastrService,
    private humanResourcesService: HumanResourcesService
  ) {}

  getReport(type: string, report: any) {
    this.loadAnimation(report, type, true);

    report.endPoint(type).subscribe({
      next: (response: ResponseObject) => {
        this.downloadHandlerResponse(response.data, type, report);
      },
      error: (error: HttpErrorResponse) => {
        this.errorHandlerResponse(error, type, report);
      }
    });
  }

  errorHandlerResponse(error: HttpErrorResponse, type: string, report: any) {
    if (error.status === 400) {
      this.toastService.error(error.error.message);
    } else {
      this.toastService.error('Error al descargar el reporte de ' + report.name);
    }

    this.loadAnimation(report, type, false);
  }

  downloadHandlerResponse(text: string, type: string, report: any) {
    downloadFile(text, type, report.name);
    this.toastService.success('Se ha descargado el reporte de ' + report.name);
    this.loadAnimation(report, type, false);
  }

  loadAnimation(report: any, type: string, isLoading: boolean) {
    if (type === 'excel') {
      report.excel = isLoading;
    }
  }
}